module.exports = __webpack_public_path__ + "static/media/Gen_06_rescan_21.b7eaaaa5.jpg";